(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[id^="ai-assistant-"]');
    if (!root) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sectionId = root.id.replace('ai-assistant-', '');
    var launcher = document.getElementById('aia-launcher-' + sectionId);
    var panel = document.getElementById('aia-panel-' + sectionId);
    var closeBtn = panel.querySelector('.aia-close');
    var messagesEl = panel.querySelector('.aia-messages');
    var typingEl = panel.querySelector('.aia-typing');
    var chipsEl = panel.querySelector('.aia-chips');
    var inputForm = panel.querySelector('.aia-input-row');
    var inputEl = panel.querySelector('.aia-input');
    var offlineEl = panel.querySelector('.aia-offline');
    var proactiveEl = document.getElementById('aia-proactive-' + sectionId);
    var proactiveCloseBtn = proactiveEl.querySelector('.aia-proactive-close');
    var proactiveTextEl = proactiveEl.querySelector('.aia-proactive-text');

    var isProduct = root.dataset.isProduct === 'true';
    var product = null;
    if (isProduct) {
      try { product = JSON.parse(root.dataset.product); } catch (e) { product = null; }
    }

    var STORAGE_KEY = 'hooked-aia-session';
    var hasInteracted = false;
    var isOpen = false;

    /* ---------- Session state (session-scoped only, per spec) ---------- */
    function getSession() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
      } catch (e) { return {}; }
    }
    function setSession(patch) {
      try {
        var s = Object.assign(getSession(), patch);
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(s));
      } catch (e) {}
    }

    /* ---------- Entrance animation ---------- */
    window.setTimeout(function () {
      launcher.classList.add('aia-ready');
    }, 700);

    /* ---------- Halo pulse every 10-15s until interaction ---------- */
    var pulseTimer = null;
    function schedulePulse() {
      if (hasInteracted || reduceMotion) return;
      var delay = 10000 + Math.random() * 5000;
      pulseTimer = window.setTimeout(function () {
        if (hasInteracted) return;
        launcher.classList.remove('aia-pulse');
        void launcher.offsetWidth;
        launcher.classList.add('aia-pulse');
        schedulePulse();
      }, delay);
    }
    schedulePulse();

    function markInteracted() {
      if (hasInteracted) return;
      hasInteracted = true;
      if (pulseTimer) window.clearTimeout(pulseTimer);
      launcher.classList.remove('aia-pulse');
      setSession({ interacted: true });
    }

    /* ---------- Open / close ---------- */
    var messagesRendered = false;

    function openPanel() {
      isOpen = true;
      panel.classList.add('aia-open');
      launcher.setAttribute('aria-expanded', 'true');
      hideProactive();
      markInteracted();
      if (!messagesRendered) {
        renderGreeting();
        messagesRendered = true;
      }
      window.setTimeout(function () { inputEl.focus(); }, reduceMotion ? 0 : 340);
    }

    function closePanel() {
      isOpen = false;
      panel.classList.remove('aia-open');
      launcher.setAttribute('aria-expanded', 'false');
      launcher.focus();
    }

    launcher.addEventListener('click', function () {
      if (isOpen) { closePanel(); } else { openPanel(); }
    });
    closeBtn.addEventListener('click', closePanel);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) closePanel();
    });

    /* ---------- Proactive message ---------- */
    var proactiveEnabled = root.dataset.proactiveEnabled === 'true';
    var proactiveDelay = (parseInt(root.dataset.proactiveDelay, 10) || 30) * 1000;
    var proactiveText = root.dataset.proactiveText || 'Need help choosing? Ask me about this product.';
    var onCart = window.location.pathname.indexOf('/cart') === 0;

    function hideProactive() {
      proactiveEl.classList.remove('aia-show');
    }

    if (isProduct && proactiveEnabled && !onCart) {
      var session = getSession();
      if (!session.interacted && !session.proactiveShown) {
        var activeMs = 0;
        var tickInterval = window.setInterval(function () {
          if (!document.hidden) activeMs += 1000;
          if (activeMs >= proactiveDelay) {
            window.clearInterval(tickInterval);
            var s = getSession();
            if (!s.interacted && !isOpen) {
              proactiveTextEl.textContent = proactiveText;
              proactiveEl.classList.add('aia-show');
              setSession({ proactiveShown: true });
            }
          }
        }, 1000);
      }
    }
    proactiveCloseBtn.addEventListener('click', function () {
      hideProactive();
      setSession({ proactiveShown: true });
    });

    /* ---------- Message rendering ---------- */
    function addMessage(html, who) {
      var el = document.createElement('div');
      el.className = 'aia-msg aia-' + who;
      el.innerHTML = html;
      messagesEl.appendChild(el);
      messagesEl.scrollTop = messagesEl.scrollHeight;
      return el;
    }

    function addProductCard(p) {
      var wrap = document.createElement('div');
      wrap.className = 'aia-product-card';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var price = typeof p.price === 'number' ? '$' + (p.price / 100).toFixed(2) : '';
      wrap.innerHTML =
        '<img src="' + img + '" alt="" loading="lazy">' +
        '<div class="aia-product-card-info"><strong>' + escapeHtml(p.title) + '</strong><span>' + price + '</span></div>';
      var container = document.createElement('div');
      container.appendChild(wrap);

      var actions = document.createElement('div');
      actions.className = 'aia-product-actions';

      var viewBtn = document.createElement('a');
      viewBtn.className = 'aia-btn-sm';
      viewBtn.href = p.url;
      viewBtn.textContent = 'View product';
      actions.appendChild(viewBtn);

      if (p.available) {
        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'aia-btn-sm aia-primary';
        addBtn.textContent = 'Add to cart';
        addBtn.addEventListener('click', function () {
          addToCart(p.variants[0].id, addBtn);
        });
        actions.appendChild(addBtn);
      }
      container.appendChild(actions);

      var msgWrap = document.createElement('div');
      msgWrap.className = 'aia-msg aia-bot';
      msgWrap.appendChild(container);
      messagesEl.appendChild(msgWrap);
      messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    function escapeHtml(str) {
      var d = document.createElement('div');
      d.textContent = str == null ? '' : String(str);
      return d.innerHTML;
    }

    function showTyping(show) {
      typingEl.classList.toggle('aia-show', show);
      if (show) messagesEl.scrollTop = messagesEl.scrollHeight;
    }

    /* ---------- Real add-to-cart (explicit click only, never automatic) ---------- */
    function addToCart(variantId, btn) {
      if (!variantId) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart add failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          var cartIcon = document.querySelector('.cart-link');
          if (cartIcon) {
            cartIcon.classList.remove('is-bumped');
            void cartIcon.offsetWidth;
            cartIcon.classList.add('is-bumped');
          }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var bubble = document.getElementById('CartBubble');
            if (bubble) {
              bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
            }
          }).catch(function () {});
        })
        .catch(function () {
          btn.textContent = 'Try again';
          btn.disabled = false;
          addMessage('Something went wrong adding that to your cart. You can also add it directly from the product page.', 'bot');
        });
    }

    /* ---------- Suggested question chips ---------- */
    function renderChips(list) {
      chipsEl.innerHTML = '';
      list.forEach(function (q) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'aia-chip';
        chip.textContent = q;
        chip.addEventListener('click', function () {
          handleUserMessage(q);
        });
        chipsEl.appendChild(chip);
      });
    }

    function productChips() {
      var chips = ['Is this right for my needs?'];
      if (product && product.options_with_values && product.options_with_values.length) {
        chips.push('What are the dimensions?');
      }
      chips.push('When could it arrive?');
      chips.push('What is the return policy?');
      return chips;
    }

    function generalChips() {
      return ['What do you sell?', 'Shipping & delivery', 'Returns policy', 'Contact a person'];
    }

    /* ---------- Greeting ---------- */
    function renderGreeting() {
      var greeting = isProduct ? root.dataset.greetingProduct : root.dataset.greetingGeneral;
      if (isProduct && product) {
        greeting = greeting.replace('this product', escapeHtml(product.title));
      }
      addMessage(escapeHtml(greeting), 'bot');
      renderChips(isProduct ? productChips() : generalChips());
    }

    /* ---------- Rule-based answer engine ----------
       Deterministic keyword matching against real store data only.
       No fabricated claims — unmatched questions get an honest fallback. */
    function findAnswer(raw) {
      var q = raw.toLowerCase();

      function has(words) {
        return words.some(function (w) { return q.indexOf(w) !== -1; });
      }

      // Dimensions / materials / specs
      if (has(['dimension', 'size', 'measurement', 'material', 'made of', 'fabric'])) {
        if (isProduct && product) {
          var desc = (product.description || '').replace(/<[^>]*>/g, ' ');
          var snippet = desc.length > 220 ? desc.slice(0, 220) + '…' : desc;
          if (snippet.trim()) {
            return 'Here\'s what\'s listed for ' + escapeHtml(product.title) + ': ' + escapeHtml(snippet) +
              ' For exact specs, the full product page has the complete details.';
          }
        }
        return 'I don\'t have exact spec data pulled in for that yet — the product page has the fullest details, or our team can confirm anything specific.';
      }

      // Suitability / "is this right for me"
      if (has(['right for my needs', 'suitable', 'is this good for', 'should i get', 'recommend'])) {
        if (isProduct && product) {
          return 'I can share the real specs and reviews for ' + escapeHtml(product.title) + ', but I don\'t know your exact trip or use case — what will you mainly be using it for?';
        }
        return 'Happy to help narrow it down — what kind of trip or activity is this gear for?';
      }

      // Price / availability
      if (has(['price', 'cost', 'how much', 'in stock', 'available'])) {
        if (isProduct && product) {
          var price = '$' + (product.price / 100).toFixed(2);
          var avail = product.available ? 'in stock' : 'currently out of stock';
          return escapeHtml(product.title) + ' is ' + price + ' and ' + avail + ' right now.';
        }
        return 'Prices and stock vary by product — tell me which item and I\'ll check it, or open it from the shop and I can see it directly.';
      }

      // Shipping
      if (has(['shipping', 'delivery', 'arrive', 'when will', 'how long'])) {
        var shipExists = root.dataset.shippingExists === 'true';
        if (shipExists) {
          return 'We have a published shipping policy with the real details — <a href="' + root.dataset.shippingPolicyUrl + '" target="_blank" rel="noopener">view shipping info</a>. Delivery times can vary by destination — where are you ordering to?';
        }
        return 'I don\'t have a published shipping policy to pull exact timeframes from — our team can give you a real estimate for your destination via the contact link below.';
      }

      // Returns
      if (has(['return', 'refund', 'exchange', 'send back'])) {
        var refundExists = root.dataset.refundPolicyExists === 'true';
        if (refundExists) {
          return 'Here\'s our real return policy — <a href="' + root.dataset.refundPolicyUrl + '" target="_blank" rel="noopener">view return policy</a>.';
        }
        return 'I don\'t see a published return policy to link you to yet — reach out via the contact link below and our team can confirm the details directly.';
      }

      // Payment
      if (has(['payment', 'pay with', 'credit card', 'paypal', 'afterpay'])) {
        return 'You\'ll see the accepted payment options at checkout — the icons shown in our footer reflect what\'s actually supported.';
      }

      // Variant / add to cart help
      if (has(['add to cart', 'checkout', 'how do i buy', 'select', 'variant', 'size guide'])) {
        if (isProduct && product && product.options_with_values && product.options_with_values.length) {
          var optNames = product.options_with_values.map(function (o) { return o.name; }).join(', ');
          return 'Pick your ' + escapeHtml(optNames) + ' on the product page, then use Add to Cart — I can also add the current selection for you below.';
        }
        return 'Once you\'ve picked any options on the product page, Add to Cart takes you straight there — I can drop a real product card in here too if you tell me what you\'re looking for.';
      }

      // Reviews
      if (has(['review', 'rating', 'feedback'])) {
        return 'You can see real customer reviews further down the homepage — I don\'t have per-product review data connected here yet, so I don\'t want to guess at ratings for this specific item.';
      }

      return null;
    }

    function handleUserMessage(text) {
      text = text.trim();
      if (!text) return;
      markInteracted();
      addMessage(escapeHtml(text), 'user');
      inputEl.value = '';
      chipsEl.innerHTML = '';

      showTyping(true);
      window.setTimeout(function () {
        showTyping(false);
        var answer = findAnswer(text);
        if (answer) {
          addMessage(answer, 'bot');
        } else {
          addMessage(
            'I\'m not able to answer that precisely yet — I only speak from real store data, so I\'d rather say so than guess. ' +
            'You can reach our team directly using the contact link below.',
            'bot'
          );
        }
        if (isProduct && product && has_(text, ['add to cart', 'buy', 'get this'])) {
          addProductCard(product);
        }
      }, 500 + Math.random() * 400);
    }

    function has_(text, words) {
      var q = text.toLowerCase();
      return words.some(function (w) { return q.indexOf(w) !== -1; });
    }

    inputForm.addEventListener('submit', function (e) {
      e.preventDefault();
      handleUserMessage(inputEl.value);
    });

    /* ---------- Offline handling ---------- */
    function updateOffline() {
      offlineEl.classList.toggle('aia-show', !navigator.onLine);
    }
    window.addEventListener('online', updateOffline);
    window.addEventListener('offline', updateOffline);
    updateOffline();
  });
})();
